import { OnsiteSearchConfiguration } from './onsite-search-configuration';

export const OnsiteSearchDefaultConfiguration: OnsiteSearchConfiguration = {
  minSearchPhraseLength: 3,
  searchInputDelay: 500,
  initialSearchResultRows: 2,
  maxSearchResults: 20,
  maxSuggestions: 4,
  maxAlternatives: 4,
};
